import React, { useContext } from "react";
import NavItem from "./navigation-item.js";
import styles from "./navigation.module.css";
import { useTranslation } from "react-i18next";
import { MembershipContext } from "hoc/membership-data";
import { Bug, House, Sticker, Settings2 } from "lucide-react";
import { Bird } from "lucide-react";

const Navigation = () => {
  const { t } = useTranslation();
  const membershipData = useContext(MembershipContext);
  const { membership } = membershipData;
  const { first_name, last_name } = membership;

  const mainNavigation = [
    {
      to: "/dashboard",
      src: <House size={24} className="icon icon-navigation" />,
      alt: t("navigation.item.dashboard-alt"),
      text: t("navigation.item.dashboard-desktop"),
      srcActive: (
        <House size={24} className="icon icon-desktop-navigation-active" />
      ),
    },
    {
      to: "/teams",
      src: <Sticker size={24} className="icon icon-navigation" />,
      alt: t("navigation.item.teams-alt"),
      text: t("navigation.item.teams"),
      srcActive: (
        <Sticker size={24} className="icon icon-desktop-navigation-active" />
      ),
    },
  ];

  const footerNavigation = [
    {
      to: "/parameters",
      src: <Settings2 size={24} className="icon icon-navigation" />,
      alt: t("navigation.item.params-alt"),
      text: t("navigation.item.params"),
      srcActive: (
        <Settings2 size={24} className="icon icon-desktop-navigation-active" />
      ),
    },
    {
      to: "/reports",
      src: <Bug size={24} className="icon icon-navigation" />,
      alt: t("navigation.item.reports-alt"),
      text: t("navigation.item.reports"),
      srcActive: (
        <Bug size={24} className="icon icon-desktop-navigation-active" />
      ),
    },
  ];

  return (
    <nav className={styles["nav-container"]}>
      <section className={`${styles.profile} mb-48`}>
        <div className={styles["picture-round"]} data-testid="profile-picture">
          <Bird size={24} className="icon" />
        </div>
        <div className={styles["profile-info"]}>
          <h4 className="title-3" data-testid="profile-name">
            {first_name} {last_name}
          </h4>
        </div>
      </section>
      <section className={styles["main-nav-items"]}>
        {mainNavigation.map((item, index) => (
          <NavItem
            key={index}
            to={item.to}
            src={item.src}
            alt={item.alt}
            text={item.text}
            srcActive={item.srcActive}
          />
        ))}
      </section>
      <section className={`${styles["footer-nav-items"]} mb-24`}>
        {footerNavigation.map((item, index) => (
          <NavItem
            key={index}
            to={item.to}
            src={item.src}
            alt={item.alt}
            text={item.text}
            srcActive={item.srcActive}
          />
        ))}
      </section>
    </nav>
  );
};

export default Navigation;
